import React from 'react';
import { PageSection } from 'adc-ui-components';

const DEVICES_SECTION = 'devices';

const PREPAID_SUPPORT = {
  heading: {
    label: 'Help & Support',
    link: {
      behavior: 'external',
      label: 'View Help & Support',
      url: 'https://www.xfinity.com/support/',
    },
  },
  columns: [],
};

const filterColumnsBySection = (columns, section) => (
  columns.filter((links) => {
    const isShared = Boolean(links && links.shared);
    const isSectionMatch = Boolean(links && links.section === section);
    return isShared || isSectionMatch;
  })
);

const CmsSupport = ({
  data,
  loading,
  isAccountResolved = true,
  accountStatus,
  isPrepaid,
  section = DEVICES_SECTION,
}) => {
  if (loading || !isAccountResolved) return null;

  const sourceData = isPrepaid ? PREPAID_SUPPORT : data;
  if (!sourceData || !Array.isArray(sourceData.columns)) {
    return null;
  }

  const heading = sourceData.heading || {};
  const headingLink = heading.link || {};
  const columns = filterColumnsBySection(sourceData.columns, section).slice(0, 4);

  const headingTarget = headingLink.behavior === 'external' ? '_blank' : '_self';
  const headingRel = headingLink.behavior === 'external' ? 'noopener noreferrer' : undefined;

  return (
    <PageSection className="ui-light cms-support" tracking-module="cms-support">
      <div className="cms-support__title">
        <h2 className="heading2">{heading.label}</h2>
        <a
          className="support-title-link"
          href={headingLink.url}
          target={headingTarget}
          rel={headingRel}
        >
          {headingLink.label}
        </a>
      </div>
      <div className="ma-grid cms-support__body">
        {columns.map((column) => {
          const links = (((column || {}).link_wrap || {}).links) || [];
          const headingHidden = !column.title;
          const colClass = `ma-grid__col ma-grid__col--1of${columns.length}`;
          const fullClass = headingHidden ? `${colClass} cms-support__no-title` : colClass;
          const colKey = [column.section || 'shared', column.title || 'untitled'].join('|');

          return (
            <div className={fullClass} key={colKey}>
              <h3 className="heading6 cms-support__heading" aria-hidden={headingHidden || undefined}>
                {column.title || '\u00A0'}
              </h3>
              <ul className="cms-support__list">
                {links.map((item) => {
                  const target = item.behavior === 'external' ? '_blank' : '_self';
                  const rel = item.behavior === 'external' ? 'noopener noreferrer' : undefined;
                  const itemKey = `${item.label}|${item.url}`;
                  return (
                    <li key={itemKey}>
                      {item.heading ? (
                        <div className="cms-support__item-heading">{item.heading}</div>
                      ) : null}
                      <a href={item.url} target={target} rel={rel}>{item.label}</a>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>
    </PageSection>
  );
};

export default CmsSupport;
